import { useSyncExternalStore } from 'react'
import { pushLocation, subscribeLocation } from './timelineFilters'

export const engagementListKeys = [
  'spend',
  'courses_completed',
  'email_clicks',
  'personal_memberships',
] as const
export type EngagementListKey = (typeof engagementListKeys)[number]
export function isEngagementList(key: string): key is EngagementListKey {
  return (engagementListKeys as readonly string[]).includes(key)
}
export function useEngagementSearch() {
  return useSyncExternalStore(subscribeLocation, () => window.location.search)
}
export function changeEngagement(
  changes: Record<string, string>,
  reset = false,
  history: 'push' | 'replace' = 'push',
) {
  const url = new URL(window.location.href)
  if (reset) clearListParams(url.searchParams)
  url.searchParams.delete('cursor')
  url.searchParams.delete('offset')
  Object.entries(changes).forEach(([key, value]) => {
    if (value) url.searchParams.set(key, value)
    else url.searchParams.delete(key)
  })
  if (history === 'replace') {
    window.history.replaceState({}, '', url)
    window.dispatchEvent(new PopStateEvent('popstate', { state: { contactQueryChange: true } }))
  } else pushLocation(url)
}
export function clearListParams(params: URLSearchParams) {
  Array.from(params.keys()).forEach((key) => {
    if (
      ['q', 'sort', 'person_status', 'cursor', 'offset', 'when', 'year'].includes(key) ||
      key.startsWith('filters[')
    )
      params.delete(key)
  })
}
export function listParams(search: string) {
  const source = new URLSearchParams(search)
  const params = new URLSearchParams()
  source.forEach((value, key) => {
    if (
      ['window', 'person_status', 'q', 'sort', 'cursor'].includes(key) ||
      key.startsWith('filters[')
    )
      params.set(key, value)
  })
  return params
}
export function engagementListPath(
  contactId: number,
  tile: EngagementListKey,
  search: string,
  csv = false,
) {
  const params = listParams(search)
  if (csv) params.set('format', 'csv')
  return `/api/v1/contacts/${contactId}/engagement/${tile}?${params}`
}
